import React, { useEffect } from 'react';
import { Button, Modal, Form, Input, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearGatewayStatus, createGatewayRequest } from '../../../../redux/reducers/clients/clientsSlice';
import { RootState } from '../../../../redux/store';
interface AddGatewayModalProps {
    visible: boolean;
    onClose: () => void;
    clientId: string;
}

const AddGatewayModal: React.FC<AddGatewayModalProps> = ({ visible, onClose, clientId }) => {
    const { t } = useTranslation(['clients', 'common']);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const { loading, error, success } = useSelector((state: RootState) => state.clients.gateways);

    const handleClose = () => {
        form.resetFields();
        dispatch(clearGatewayStatus());
        onClose();
    };

    const onFinish = (values: { gsm: string; gateway: string }) => {
        if (clientId) {
            dispatch(createGatewayRequest({ companyId: clientId, data: values }));
        }
    };

    useEffect(() => {
        if (success && visible) {
            notification.success({ message: t('clients:gateway_add_success') });
            handleClose();
        }
        if (error) {
            notification.error({ message: t(error) });
            dispatch(clearGatewayStatus());
        }
    }, [success, error, visible]);

    return (
        <Modal
            centered={true}
            title={t('clients:add_new_gateway')}
            visible={visible}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    {t('cancel')}
                </Button>,
                <Button style={{ backgroundColor: '#02b9d9' }} key="submit" type="primary" loading={loading} onClick={() => form.submit()}>
                    {t('save')}
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false}>
                <Form.Item name="gsm" label={t('clients:gsm_number')} rules={[{ required: true, message: t('clients:field_is_required') }]}>
                    <Input placeholder={t('clients:enter_gsm_number')} />
                </Form.Item>
                <Form.Item name="gateway" label={t('clients:gateway')} rules={[{ required: true, message: t('clients:field_is_required') }]}>
                    <Input placeholder={t('clients:enter_gateway')} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddGatewayModal;